// extracted by mini-css-extract-plugin
module.exports = {"smallerFont":"ElapsedTimer_smallerFont__2IlN1"};